'use strict';

import { graphql } from 'react-relay';

export const sbRespCreatorsRoot = graphql`
    query sbRespCreatorsRootQuery(
        $userId: String = ""
        $personalizationId: String = ""
        $guestId: String = ""
        $fetchUser: Boolean!
        $uriRef: String = ""
        $originalUrl: String = ""
        $localeOrigin: String = ""
        $isTrade: Boolean!
        $showSeller: Boolean!
        $userZipCode: String = ""
        $userCountryCode: String = ""
        $fetchRegionalInfo: Boolean = false
        $first: Int
        $page: Int
        $regions: String
        $disableForceFacet: Boolean = true
        $contentModuleId: String
        $disableNonParameterizedUrlRedirects: Boolean = false
        $followSearchPages: [String]
        $followSearchTypes: [types] = [SEARCH, USER_PREFERENCE]
        $relatedBuyPagesCount: Int = 6
        $pageDisplayEnum: PageDisplayEnum = searchAndBrowse
        $priceBookName: String
    ) {
        viewer {
            ...SbRespCreatorsLayout_viewer
            ...sharedSbCreatorsRoute_viewer
        }
    }
`;
